import axios from 'axios'

export const useAxiosStrapi = () => {
  const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL,
  })

  return {
    get: axiosInstance.get.bind(axiosInstance),
    post: axiosInstance.post.bind(axiosInstance),
  }
}

export const useAxiosApi = () => {
  const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
  })

  return {
    get: axiosInstance.get.bind(axiosInstance),
    post: axiosInstance.post.bind(axiosInstance),
  }
}
